import { render, staticRenderFns } from "./MeusPedidos.vue?vue&type=template&id=94831118"
import script from "./MeusPedidos.vue?vue&type=script&lang=js"
export * from "./MeusPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports